module.exports = __webpack_public_path__ + "assets/img/info.0531ae90.svg";